module.exports = __webpack_public_path__ + "img/menu_bottom_10.9e4d7f78.svg";